import React, { Component } from 'react';
import { array, bool, func, number, shape, string } from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import pickBy from 'lodash/pickBy';
import classNames from 'classnames';
import config from '../../config';
import routeConfiguration from '../../routeConfiguration';
import { withViewport } from '../../util/contextHelpers';
import { parse, stringify } from '../../util/urlHelpers';
import { createResourceLocatorString, pathByRouteName } from '../../util/routes';
import { propTypes } from '../../util/types';
import { pushToPath } from '../../util/urlHelpers';
import { cancelSubscriptionWithRefund } from '../../util/api';
import {
  Button,
  LimitedAccessBanner,
  Logo,
  Modal,
  ModalMissingInformation,
  NamedLink,
  TopbarDesktop,
  TopbarMobileMenu,
} from '../../components';
import { TopbarSearchForm } from '../../forms';

import MenuIcon from './MenuIcon';
import SearchIcon from './SearchIcon';
import css from './Topbar.module.css';
import { findOptionsForSelectFilter } from '../../util/search';
import { turnCustomerIntoProviderMaybe } from '../../containers/EditListingPage/utils';

const MAX_MOBILE_SCREEN_WIDTH = 768;

const redirectToURLWithModalState = (props, modalStateParam) => {
  const { history, location } = props;
  const { pathname, search, state } = location;
  const searchString = `?${stringify({ [modalStateParam]: 'open', ...parse(search) })}`;
  history.push(`${pathname}${searchString}`, state);
};

const redirectToURLWithoutModalState = (props, modalStateParam) => {
  const { history, location } = props;
  const { pathname, search, state } = location;
  const queryParams = pickBy(parse(search), (v, k) => {
    return k !== modalStateParam;
  });
  const stringified = stringify(queryParams);
  const searchString = stringified ? `?${stringified}` : '';
  history.push(`${pathname}${searchString}`, state);
};

const GenericError = props => {
  const { show } = props;
  const classes = classNames(css.genericError, {
    [css.genericErrorVisible]: show,
  });
  return (
    <div className={classes}>
      <div className={css.genericErrorContent}>
        <p className={css.genericErrorText}>
          <FormattedMessage id="Topbar.genericError" />
        </p>
      </div>
    </div>
  );
};

GenericError.propTypes = {
  show: bool.isRequired,
};

class TopbarComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subscriptionPopupOpen: false,
      subscriptionError: null,
    };

    this.handleMobileMenuOpen = this.handleMobileMenuOpen.bind(this);
    this.handleMobileMenuClose = this.handleMobileMenuClose.bind(this);
    this.handleMobileSearchOpen = this.handleMobileSearchOpen.bind(this);
    this.handleMobileSearchClose = this.handleMobileSearchClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleChangeUserType = this.handleChangeUserType.bind(this);
    this.onHandleSubscriptionPopup = this.onHandleSubscriptionPopup.bind(this);
  }

  handleMobileMenuOpen() {
    redirectToURLWithModalState(this.props, 'mobilemenu');
  }

  handleMobileMenuClose() {
    redirectToURLWithoutModalState(this.props, 'mobilemenu');
  }

  handleMobileSearchOpen() {
    redirectToURLWithModalState(this.props, 'mobilesearch');
  }

  handleMobileSearchClose() {
    redirectToURLWithoutModalState(this.props, 'mobilesearch');
  }

  handleSubmit(values) {
    const { currentSearchParams, providerType } = this.props;
    const { location, pub_keywords, pub_category, ...rest } = values;
    // const { search, selectedPlace } = location;
    const { history } = this.props;
    // const { origin, bounds } = selectedPlace;
    // const originMaybe = config.sortSearchByDistance ? { origin } : {};

    const isProvider =
      this.props.currentUser?.attributes?.profile?.publicData?.userType === 'service-provider';
    const categoryOptions = findOptionsForSelectFilter('category', config.custom.filters);
    const keywordsValue = pub_keywords?.toLowerCase().split(' ') || '';
    const foundCategory = categoryOptions.find(c => c.label.toLowerCase() === keywordsValue);
    // const categorySearch = foundCategory ? { pub_category: foundCategory.key } : {};
    // const keywordsSearch = foundCategory ? {} : { keywords };
    const keywordsSearch = { pub_keywords };

    const searchParams = {
      pub_listingType: 'provider',
      pub_category,
      // ...categorySearch,
      ...currentSearchParams,
      // ...originMaybe,
      // address: search,
      // bounds,
      ...keywordsSearch,
      ...rest,
    };

    let searchLinkUrl = `/s?pub_listingType=provider&pub_providerType=${providerType}&`

    if (!!pub_category) {
      searchLinkUrl = searchLinkUrl + `pub_category=has_any:${pub_category}&`
    }
    if (!!searchParams?.pub_keywords?.trim()?.length) {
      searchLinkUrl = searchLinkUrl + `pub_keywords=has_any:${keywordsValue}&`
    }

    history.push(searchLinkUrl)
    // history.push(createResourceLocatorString('SearchPage', routeConfiguration(), {}, searchParams));
  }

  handleLogout() {
    const { onLogout, history } = this.props;
    onLogout().then(() => {
      const path = pathByRouteName('LandingPage', routeConfiguration());

      // In production we ensure that data is really lost,
      // but in development mode we use stored values for debugging
      if (config.dev) {
        history.push(path);
      } else if (typeof window !== 'undefined') {
        window.location = path;
      }

      console.log('logged out'); // eslint-disable-line
    });
  }

  onHandleSubscriptionPopup(status) {
    this.setState({ subscriptionPopupOpen: status });
    this.setState({ subscriptionError: null });
  }

  handleChangeUserType() {

    const { currentUser } = this.props
    const subscriptionId = currentUser?.attributes?.profile?.privateData?.subscriptionId || null;

    if (!!subscriptionId) {
      cancelSubscriptionWithRefund({ subscriptionId })
        .then(() => turnCustomerIntoProviderMaybe(true))
        .then(() => {
          this.setState({ subscriptionPopupOpen: false });
          const path = pathByRouteName('SubscriptionPage', routeConfiguration());
          return window.location = path;
        })
        .catch(err => {
          console.log(err);
          this.setState({ subscriptionError: err.message });
        });
    }

    else {
      turnCustomerIntoProviderMaybe(true)
        .then(() => {
          this.setState({ subscriptionPopupOpen: false });
          const path = pathByRouteName('NewListingPageProvider', routeConfiguration());
          return window.location = path;
        })
        .catch(err => {
          this.setState({ subscriptionError: 'Oops, something went wrong. Please refresh the page and try again.' });
          console.log(err);
        });
    }
  }

  render() {
    const {
      className,
      rootClassName,
      desktopClassName,
      mobileRootClassName,
      mobileClassName,
      isAuthenticated,
      authScopes,
      authInProgress,
      currentUser,
      currentUserHasListings,
      currentUserListing,
      currentUserListingFetched,
      currentUserHasOrders,
      currentPage,
      notificationCount,
      viewport,
      intl,
      location,
      onManageDisableScrolling,
      onResendVerificationEmail,
      sendVerificationEmailInProgress,
      sendVerificationEmailError,
      showGenericError,
      providerType
    } = this.props;

    const { mobilemenu, mobilesearch, address, origin, bounds } = parse(location.search, {
      latlng: ['origin'],
      latlngBounds: ['bounds'],
    });
    const searchParams = new URLSearchParams(location.search);
    const pub_keywords = searchParams.get('pub_keywords');

    const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;

    const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;
    const isMobileMenuOpen = isMobileLayout && mobilemenu === 'open';
    const isMobileSearchOpen = isMobileLayout && mobilesearch === 'open';

    const isDashboard =
      typeof window !== 'undefined' && window.location.pathname === '/admin-users';
    const currentUserNotApproved =
      currentUser &&
      currentUser?.attributes?.profile?.protectedData?.approved === 'false' &&
      !currentUser?.attributes?.profile?.protectedData?.admin &&
      !isDashboard;

    const mobileMenu = (
      <TopbarMobileMenu
        isAuthenticated={isAuthenticated}
        currentUserHasListings={currentUserHasListings}
        currentUserListing={currentUserListing}
        currentUserListingFetched={currentUserListingFetched}
        currentUser={currentUser}
        onLogout={this.handleLogout}
        notificationCount={notificationCount}
        currentPage={currentPage}
        onHandleSubscriptionPopup={() => this.onHandleSubscriptionPopup(true)}
      />
    );

    // Only render current search if full place object is available in the URL params
    const locationFieldsPresent = config.sortSearchByDistance
      ? address && origin && bounds
      : address && bounds;
    const initialSearchFormValues = {
      pub_keywords: pub_keywords ? pub_keywords.substring(8).split(',').join(' ') : '',
      location: locationFieldsPresent
        ? {
          search: address,
          selectedPlace: { address, origin, bounds },
        }
        : null,
    };

    const classes = classNames(rootClassName || css.root, className);

    return (
      <div className={classes}>
        <LimitedAccessBanner
          isAuthenticated={isAuthenticated}
          authScopes={authScopes}
          currentUser={currentUser}
          onLogout={this.handleLogout}
          currentPage={currentPage}
        />
        {currentUserNotApproved && (
          <div className={css.notApprovedWrapper}>
            <div className={css.notApprovedText}>
              Your account requires verification and approval by the platform administrator
            </div>
          </div>
        )}
        <div className={classNames(mobileRootClassName || css.container, mobileClassName)}>
          <Button
            rootClassName={css.menu}
            onClick={this.handleMobileMenuOpen}
            title={intl.formatMessage({ id: 'Topbar.menuIcon' })}
          >
            <MenuIcon className={css.menuIcon} />
            {notificationDot}
          </Button>
          <NamedLink
            className={css.home}
            name="LandingPage"
            title={intl.formatMessage({ id: 'Topbar.logoIcon' })}
          >
            <Logo format="mobile" />
          </NamedLink>
          <Button
            rootClassName={css.searchMenu}
            onClick={this.handleMobileSearchOpen}
            title={intl.formatMessage({ id: 'Topbar.searchIcon' })}
          >
            <SearchIcon className={css.searchMenuIcon} />
          </Button>
        </div>
        <div className={css.desktop}>
          <TopbarDesktop
            className={desktopClassName}
            currentUserHasListings={currentUserHasListings}
            currentUserListing={currentUserListing}
            currentUserListingFetched={currentUserListingFetched}
            currentUser={currentUser}
            currentPage={currentPage}
            initialSearchFormValues={initialSearchFormValues}
            intl={intl}
            isAuthenticated={isAuthenticated}
            notificationCount={notificationCount}
            pub_keywords={pub_keywords}
            onLogout={this.handleLogout}
            onSearchSubmit={this.handleSubmit}
            onHandleSubscriptionPopup={() => this.onHandleSubscriptionPopup(true)}
            history={this.props.history}
            providerType={providerType}
          />
        </div>
        <Modal
          id="TopbarMobileMenu"
          isOpen={isMobileMenuOpen}
          onClose={this.handleMobileMenuClose}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
        >
          {authInProgress ? null : mobileMenu}
        </Modal>
        <Modal
          id="TopbarMobileSearch"
          containerClassName={css.modalContainer}
          isOpen={isMobileSearchOpen}
          onClose={this.handleMobileSearchClose}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <div className={css.searchContainer}>
            <TopbarSearchForm
              pub_keywords={pub_keywords}
              onSubmit={this.handleSubmit}
              // initialValues={initialSearchFormValues}
              isMobile
              providerType={providerType}
            />
            <p className={css.mobileHelp}>
              <FormattedMessage id="Topbar.mobileSearchHelp" />
            </p>
          </div>
        </Modal>
        <Modal
          id="TopbarSubscriptionInfo"
          isOpen={this.state.subscriptionPopupOpen}
          onClose={() => this.onHandleSubscriptionPopup(false)}
          usePortal
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <div className={css.subscriptionInfo}>
            <h3 className={css.subscriptionInfoText}>
              <FormattedMessage id="Topbar.subscriptionText" />
            </h3>
            <ul className={css.subscriptionInfoList}>
              <li>
                <FormattedMessage id="Topbar.subscriptionListItem1" />
              </li>
              <li>
                <FormattedMessage id="Topbar.subscriptionListItem2" />
              </li>
              <li>
                <FormattedMessage
                  id="Topbar.subscriptionListItem3"
                  values={{
                    contactUs: (
                      <NamedLink
                        className={css.subscriptionInfoLink}
                        name="ContactPage"
                      >
                        <FormattedMessage id="Topbar.subscriptionContactUs" />
                      </NamedLink>
                    )
                  }}
                />
              </li>
            </ul>

            <div className={css.subscriptionInfoButtons}>
              <div
                className={css.subscriptionInfoButton}
                onClick={() => this.onHandleSubscriptionPopup(false)}
              >
                <FormattedMessage id="Topbar.subscriptionCancel" />
              </div>

              <div
                className={css.subscriptionInfoButton}
                onClick={() => this.handleChangeUserType()}
              >
                <FormattedMessage id="Topbar.subscriptionConfirm" />
              </div>
            </div>

            {!!this.state.subscriptionError && (
              <p className={css.error}>
                {this.state.subscriptionError}
              </p>
            )}

          </div>
        </Modal>
        <ModalMissingInformation
          id="MissingInformationReminder"
          containerClassName={css.missingInformationModal}
          currentUser={currentUser}
          currentUserHasListings={currentUserHasListings}
          currentUserHasOrders={currentUserHasOrders}
          location={location}
          onManageDisableScrolling={onManageDisableScrolling}
          onResendVerificationEmail={onResendVerificationEmail}
          sendVerificationEmailInProgress={sendVerificationEmailInProgress}
          sendVerificationEmailError={sendVerificationEmailError}
        />

        <GenericError show={showGenericError} />
      </div>
    );
  }
}

TopbarComponent.defaultProps = {
  className: null,
  rootClassName: null,
  desktopClassName: null,
  mobileRootClassName: null,
  mobileClassName: null,
  notificationCount: 0,
  currentUser: null,
  currentUserHasOrders: null,
  currentPage: null,
  sendVerificationEmailError: null,
  authScopes: [],
};

TopbarComponent.propTypes = {
  className: string,
  rootClassName: string,
  desktopClassName: string,
  mobileRootClassName: string,
  mobileClassName: string,
  isAuthenticated: bool.isRequired,
  authScopes: array,
  authInProgress: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentUserHasListings: bool.isRequired,
  currentUserHasOrders: bool,
  currentPage: string,
  notificationCount: number,
  onLogout: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  onResendVerificationEmail: func.isRequired,
  sendVerificationEmailInProgress: bool.isRequired,
  sendVerificationEmailError: propTypes.error,
  showGenericError: bool.isRequired,

  // These are passed from Page to keep Topbar rendering aware of location changes
  history: shape({
    push: func.isRequired,
  }).isRequired,
  location: shape({
    search: string.isRequired,
  }).isRequired,

  // from withViewport
  viewport: shape({
    width: number.isRequired,
    height: number.isRequired,
  }).isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const Topbar = compose(
  withViewport,
  injectIntl
)(TopbarComponent);

Topbar.displayName = 'Topbar';

export default Topbar;
